import AddIcon from '@mui/icons-material/Add'
import { Button } from '@mui/material'
import type React from 'react'
import { type ReactNode, useEffect, useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { ConversionModalAddDialog } from './ConversionModalAddDialog'
import type { ConversionInfo } from '../interfaces/ConversionIf'

type ConversionAddButtonProps = {
  children: ReactNode
  title: string
  conversions: ConversionInfo[]
  overwrite?: boolean
  onAdd: (pre_text: string, post_text: string) => void
}

export const ConversionAddButton: React.FC<ConversionAddButtonProps> = props => {
  const { conversions, onAdd } = props
  const auth = useAuth()
  const [open, setOpen] = useState(false)
  const [inputPreTextValue, setinputPreTextValue] = useState('')
  const [inputPostTextValue, setinputPostTextValue] = useState('')

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSave = (pre_text: string, post_text: string) => {
    setinputPreTextValue(pre_text)
    setinputPostTextValue(post_text)
  }

  const onClickHandler = async () => {
    handleOpen()
  }

  useEffect(() => {
    if (inputPreTextValue && inputPostTextValue) {
      onAdd(inputPreTextValue, inputPostTextValue)
      setinputPreTextValue('')
      setinputPostTextValue('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputPreTextValue, inputPostTextValue])

  return (
    <>
      {open && (
        <ConversionModalAddDialog
          open={open}
          title={props.title}
          conversions={conversions}
          overwrite={props.overwrite}
          onClose={handleClose}
          onSave={handleSave}
        />
      )}
      <Button
        disabled={auth.isDisable}
        onClick={onClickHandler}
        startIcon={<AddIcon sx={{ width: 40, height: 40, paddingBottom: '6px' }} />}
        sx={{
          marginBottom: '24px',
          justifyContent: 'flex-start',
          color: '#282828',
          font: 'normal normal bold 21px/32px Noto Sans JP',
          paddingTop: '6px',
          paddingLeft: '30px',
          textAlign: 'left',
          backgroundColor: '#fff16f',
          '&:hover': {
            backgroundColor: 'rgba(255, 241, 111, 0.8)',
          },
          boxShadow: '0px 2px 2px #00000014',
          height: '80px',
          width: '400px',
          borderRadius: '40px',
          '& .MuiSvgIcon-root': {
            fontSize: '32px',
          },
        }}
      >
        {props.children}
      </Button>
    </>
  )
}
